import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/shared";

import { useFormatAge } from "src/common/hooks/useFormatAge";
import { useLastEventValueByQuery } from "src/features/events";

export function useAge(): string | undefined {
	const { formatDate } = useIntl();
	const formatAge = useFormatAge();

	const value = useLastEventValueByQuery<string>(queries.dateOfBirth);
	return value === undefined
		? undefined
		: `${formatAge(value)} - ${formatDate(value, {
				year: "numeric",
				month: "numeric",
				day: "numeric"
			})}`;
}
